module.exports = __webpack_public_path__ + "img/money-free.b21fe93b.svg";